'use client';

import { useEffect, useState } from 'react';

const SEEN_KEY = 'rushmid:howto:seen';

export const useFirstRun = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(SEEN_KEY)) setOpen(true);
    } catch { }
  }, []);

  const dismiss = () => {
    setOpen(false);
    try { localStorage.setItem(SEEN_KEY, '1'); } catch { }
  };

  return { open, dismiss };
};
